<template>
<div class="cooperation">
  <div class="compInfo">
    <div class="tit">公司简介</div>
    <div class="cont">大方租车创立于2011年3月，总部位于武汉，是中国共享租车连锁品牌，门店数量全国前三，覆盖全国300多个城市，为客户提供租车、以租代购买车、私家车共享等用车服务，在用户体验上实现了线上支付、线上预授权、上门送取车等全程线上化服务，与芝麻信用战略合作，进入支付宝推荐信用出行品牌，芝麻信用550分可享免押金租车，全面入驻支付宝信用出行、携程、同程、途牛、飞猪、京东信用出行等出行平台。 
  </div>
    <div class="cont">公司已成功完成A轮融资，获得国家政策性产业基金——德瑞恒通创业投资基金以及上海毓道投资管理有限公司的股权投资。</div>
    <div class="tit">合作伙伴</div>
    <div class="icon">
      <img src="@/assets/images/parter01.png" alt="">
      <img src="@/assets/images/parter02.png" alt="">
      <img src="@/assets/images/parter03.png" alt="">
      <img src="@/assets/images/parter04.png" alt="">
      <img src="@/assets/images/parter05.png" alt="">
      <img src="@/assets/images/parter06.png" alt="">
    </div>
    <p class="address">公司地址：武汉市武昌区中北路领寓大厦4F大方租车</p>
  </div>
  <div class="form">
    <img src="@/assets/images/coomprabanner.png" alt="">
    <input type="text" placeholder="合作目的" v-model="county">
    <input type="text" placeholder="联系人姓名*" v-model="userName">
    <input type="text" placeholder="联系方式*" v-model="userPhoneNum">
    <button class="submit" @click="submit">提交</button>
    <button class="phone" @click="callme">电话咨询</button>
    <!-- <a class="phone" href="tel:4006668818" ></a> -->
    <p>提交成功后，将会有工作人员与您联系</p>
  </div>
</div>

</template>
<script>
import {jsonp} from '@/utils/api'
import { resourceUrl,orderSource} from "@/utils/env";
export default {
  name: "cooperation",
  data() {
    return {
      isShow: false,
      userName:'',
      userPhoneNum:'',
      county:''
    }
  },
  props: [],
  methods: {
    async submit(){
      if(this.userName == "" || this.userPhoneNum == "" || this.county == "") {
          this.flexible.showToast({
            content: "请完善信息",
            duration: 2000
          });
          return
        }
      var reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (!reg.test(this.userPhoneNum)) {
          this.flexible.showToast({
            content: "手机格式不正确",
            duration: 2000
          });
          return
      }
      
     this.$http({
       method:'jsonp',
       url:'http://jiameng.dafang24.com/api/api/post_jiameng',
       jsonp:'callback',
       params:{
         "name": this.userName,
          "call": this.userPhoneNum,
          "area": this.county
       }
     }).then((response)=>{
       console.log(response);
        this.flexible.showToast({
          content: "提交成功",
          duration: 2000
        });
     },(response)=>{
        this.flexible.showToast({
          content: "提交失败",
          duration: 2000
        });
     }) 
    },
    callme(){
       if(orderSource==17){
        window.webkit.messageHandlers.goPhone.postMessage('4006668818');
      }else if(orderSource==16){
        dfpanda.callPhone('4006668818');
      } 
    }

  }
};
</script>
<style lang="scss" scoped type="text/scss">
.cooperation {
  width:100%;
  height:100%;
  padding-top:10px;
  background:url(~@/assets/images/coomprabg.png) no-repeat 0 -110px;
  background-color:#fff;
  background-size: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
  color:#434343;
    .compInfo{
      padding:37px 35px;
      width:680px;
      border-radius: 10px;
      background:#fff;
      font-size: 22px;
      box-shadow:0px 0px 20px rgba(51,51,51,0.14);
      .cont{
        margin-bottom:20px;
        text-indent: 2em;
        line-height: 40px;
      }
      .tit{
       padding-bottom:23px;
       text-align: center;
      }
      .icon{
        width:100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top:10px;
      }
      img{
        width:180px;
        height:80px;
        margin-bottom:22px;
      }
      p{
        width:100%;
        padding-top:18px;
        text-align: center;
      }
    }

    .form{
      width:680px;
      display: flex;
      flex-direction: column;
      align-items: center;
      img{
        width:480px;
        margin-top:20px;
      }
      input{
        width:600px;
        height:90px;
        padding-left:31px;
        border-radius:8px;
        margin-top:34px;
        background:#EFEFEF;
        color:#999999;
      }
      button,.phone{
        width:600px;
        height:90px;
        border-radius:45px;
        font-size: 32px;
        outline: none;
        margin-bottom:23px;
        text-align: center;
        line-height: 90px;
      }
      .submit{
        background: #FF8307;
        color:white;
        border:none;
        margin-top:50px;
      }
      .phone{
        background: #ffffff;
        color:#FF8307;
        border: 1px solid #FF8307;/**no**/
      }
      p{
        margin-bottom:57px;
      }
    }

}
</style>
